import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES } from '../../shared/constants'
import RoundRadioButton from '../../Assets/Images/icons/roundRadioButton'
import { Checkbox, ErrorMessage, Input, SelectDashboard } from '../Form'
import { styles } from './styles'

const CampaignTargetingEdit = ({ targeting, setValue, errors }) => {
  const {
    targetType,
    targetGender,
    targetIncome,
    targetAgeGroups,
    applyNicheTargeting,
    nicheTargetingDescription,
  } = targeting
  return (
    <div>
      <Row>
        <Col xs={12}>
          <div style={styles.targetTypeContainer}>
            <span className={'label'} style={styles.label}>
              Target Type*
            </span>
            <div
              style={styles.radioButtonWrapper}
              onClick={() =>
                setValue('targetType', CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES.B2C)
              }
            >
              <RoundRadioButton
                active={targetType === CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES.B2C}
              />
              <span className={'checkBoxTitle'}>B2C</span>
            </div>
            <div
              style={styles.radioButtonWrapper}
              onClick={() =>
                setValue('targetType', CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES.B2B)
              }
            >
              <RoundRadioButton
                active={targetType === CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES.B2B}
              />
              <span className={'checkBoxTitle'}>B2B</span>
            </div>
          </div>
          <ErrorMessage message={errors['targetType']} />
        </Col>
      </Row>

      {targetType === CAMPAIGN_DEMOGRAPHICS_TARGET_TYPES.B2C && (
        <React.Fragment>
          <Row style={styles.rowMarginTop16}>
            <Col xs={6}>
              <SelectDashboard
                onChange={(a, b, value) => setValue('targetGender', value)}
                options={[
                  { label: 'M/F (both)', value: 'BOTH' },
                  { label: 'M', value: 'M' },
                  { label: 'F', value: 'F' },
                ]}
                label="Genders*"
                value={targetGender}
                error={errors['targetGender']}
                cypress_id="create-campaign-target-gender-select"
              />
            </Col>
            <Col xs={6}>
              <SelectDashboard
                onChange={(a, b, value) => setValue('targetIncome', value)}
                options={[
                  { label: 'Low', value: 'LOW' },
                  { label: 'Medium', value: 'MEDIUM' },
                  { label: 'High', value: 'HIGH' },
                ]}
                label="Income*"
                value={targetIncome}
                input={{ multiple: true }}
                error={errors['targetIncome']}
                cypress_id="create-campaign-target-income-select"
              />
            </Col>
          </Row>

          <Row style={styles.rowMarginTop16Flex}>
            <Col xs={6}>
              <SelectDashboard
                onChange={(a, b, value) => setValue('targetAgeGroups', value)}
                options={[
                  { label: '18–25', value: '18_25' },
                  { label: '25–35', value: '25_35' },
                  { label: '35–45', value: '35_45' },
                  { label: '45–55', value: '45_55' },
                  { label: '55+', value: '55_PLUS' },
                ]}
                label="Age Group*"
                value={targetAgeGroups}
                input={{ multiple: true }}
                error={errors['targetAgeGroups']}
                cypress_id="create-campaign-target-age-group-select"
              />
            </Col>
            <Col xs={6}>
              <Checkbox
                input={{
                  value: applyNicheTargeting,
                  onClick: () =>
                    setValue('applyNicheTargeting', !applyNicheTargeting),
                }}
                label="Apply Niche Targeting"
              />
            </Col>
          </Row>

          {applyNicheTargeting && (
            <Row style={styles.rowMarginTop8}>
              <Col xs={12}>
                <Input
                  type="text"
                  label="Niche Targeting Description*"
                  value={nicheTargetingDescription}
                  onChange={e =>
                    setValue('nicheTargetingDescription', e.target.value)
                  }
                  error={errors['nicheTargetingDescription']}
                  maxLength={250}
                />
              </Col>
            </Row>
          )}
        </React.Fragment>
      )}
    </div>
  )
}

export default CampaignTargetingEdit
